import TYPES from 'common/components/table/store/types';
import { get } from 'utils/api';
import _get from 'lodash/get';

import { parse } from './payloadParser';

const aliases = {
  authorization: 'ocean-users',
  vessel_situations: 'vessel-situations',
  vessel_prefixes: 'vessel-prefixes',
  vessel_documents: 'enums/vessel-document-categories',
  vessel_types: 'enums/vessel-types',
  vessel_subtypes: 'enums/vessel-subtypes',
  widget_types: 'widget-types',
  cp_forms: 'cp-forms',
  classification_societies: 'classification-societies',
  routing_areas: 'routing-areas',
  fuel_grades: 'fuel-grades',
  log_reports: 'log-reports',
  crons: 'job-log-reports',
  routes: 'routes',
  report_types: 'report-types',
  vts: 'vts-vessels',
  airports: 'enums/airports',
  airlines: 'enums/airlines',
  ports_map: 'ports',
  units: 'enums/units',
  crew_identifiers: 'enums/identifiers',
  crew_statuses: 'enums/crew-statuses',
  crew_evaluation_criteria: '/enums/evaluation-criteria',
  crew_evaluation_criteria_categories: 'enums/evaluation-criteria-categories',
  crew_evaluation_template_types: 'enums/crew-evaluation-template-types',
  crew_evaluation_template_reasons: 'enums/crew-evaluation-template-reasons',
  crew_rank: 'enums/crew-ranks',
  agent_types: 'enums/agent-types',
  countries: 'enums/countries',
  nationalities: 'enums/nationalities',
  currencies: 'enums/currencies',
  tools: 'enums/tools',
  laytime_events: 'enums/laytime-events',
  ld_terms: 'enums/ld-terms',
  beacon_posts: 'beacon/posts',
  crew_matrices: 'crew-matrices',
  event_types: 'enums/event-types',
  purchasing_groups: 'enums/purchasing-groups',
  purchasing_stores: 'enums/purchasing-stores'
};

export const getTableList = params => dispatch => {
  const { table, ...rest } = params;

  dispatch({ type: TYPES.GET_TABLE_LIST.START, payload: { params: rest, table } });

  return get(`/${_get(aliases, table, table)}`, rest)
    .then(response => {
      if (
        params &&
        params.paging &&
        response.data.meta &&
        parseInt(params.paging.current_page) > response.data.meta.last_page
      ) {
        dispatch(
          getTableList({
            ...params,
            paging: { ...params.paging, current_page: parseInt(params.paging.current_page) - 1 }
          })
        );
      } else {
        dispatch({
          type: TYPES.GET_TABLE_LIST.SUCCESS,
          payload: { data: parse(response.data, params, table), table }
        });
      }
    })
    .catch(error => dispatch({ type: TYPES.GET_TABLE_LIST.ERROR, payload: { error, table } }));
};

export { updateTableRow, resetTableRowUpdate } from 'common/components/table/store/actions';
